import React from 'react'

export type ReviewItemProps = {
  title: string
  value: string | React.ReactNode
  orientation?: 'horizontal' | 'vertical'
}

export function ReviewItem({ title, value, orientation = 'horizontal' }: ReviewItemProps) {
  const isHorizontal = orientation === 'horizontal'
  
  return (
    <li className="py-3 sm list-none">
      <div className={`flex ${isHorizontal ? 'flex-row items-start space-x-4 rtl:space-x-reverse justify-between' : 'flex-col space-y-2'}`}>
        <div className={`${isHorizontal ? 'flex-shrink-0 w-[150px]' : 'w-full'} overflow-hidden`}>
          <p className="text-sm font-medium dark:text-white break-words">{title}</p>
        </div>
        <div className={`flex-1 ${isHorizontal ? 'text-gray-700 text-sm text-right' : 'text-gray-700 text-sm'}`}>
          {typeof value === 'string' ? (
            <p className="break-words">{value}</p>
          ) : (
            <div className="break-words">{value}</div>
          )}
        </div>
      </div>
    </li>
  )
}